/**
 * Joins an array of filter condition arrays with a logical operator,
 * returning the correct DevExtreme/custom filter expression format:
 *
 *   0 parts → null                          (no filter)
 *   1 part  → part                          (single condition, no wrapping)
 *   N parts → [p0, op, p1, op, p2, ...]
 *
 * @param parts    - Array of individual filter conditions, e.g. [['field','=','value'], ...]
 * @param operator - Logical operator to interleave. Defaults to 'AND'.
 * @returns A combined filter expression, or null if parts is empty.
 */
export function buildFilters(parts: unknown[][], operator: string = 'AND'): unknown[] | null {
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0];
  return parts.flatMap((part, i) => (i < parts.length - 1 ? [part, operator] : [part]));
}
